// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_ACCESSORIES_INWARD_REQUEST_DK = 'FETCH_ACCESSORIES_INWARD_REQUEST_DK';
export const FETCH_ACCESSORIES_INWARD_SUCCESS_DK = 'FETCH_ACCESSORIES_INWARD_SUCCESS_DK';
export const FETCH_ACCESSORIES_INWARD_FAILURE_DK = 'FETCH_ACCESSORIES_INWARD_FAILURE_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_ACCESSORIES_INWARD_STYLE_REQUEST_DK = 'FETCH_ACCESSORIES_INWARD_STYLE_REQUEST_DK';
export const FETCH_ACCESSORIES_INWARD_STYLE_SUCCESS_DK = 'FETCH_ACCESSORIES_INWARD_STYLE_SUCCESS_DK';
export const FETCH_ACCESSORIES_INWARD_STYLE_FAILURE_DK = 'FETCH_ACCESSORIES_INWARD_STYLE_FAILURE_DK';

export const FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_REQUEST_DK = 'FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_REQUEST_DK';
export const FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_SUCCESS_DK = 'FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_SUCCESS_DK';
export const FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_FAILURE_DK = 'FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_FAILURE_DK';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_ACCESSORIES_INWARD_REQUEST_DK = 'CREATE_ACCESSORIES_INWARD_REQUEST_DK';
export const CREATE_ACCESSORIES_INWARD_SUCCESS_DK = 'CREATE_ACCESSORIES_INWARD_SUCCESS_DK';
export const CREATE_ACCESSORIES_INWARD_FAILURE_DK = 'CREATE_ACCESSORIES_INWARD_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_ACCESSORIES_INWARD_DK = 'CREATE_USER_FORM_ACCESSORIES_INWARD_DK';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_ACCESSORIES_INWARD_REQUEST_DK = 'UPDATE_ACCESSORIES_INWARD_REQUEST_DK';
export const UPDATE_ACCESSORIES_INWARD_SUCCESS_DK = 'UPDATE_ACCESSORIES_INWARD_SUCCESS_DK';
export const UPDATE_ACCESSORIES_INWARD_FAILURE_DK = 'UPDATE_ACCESSORIES_INWARD_FAILURE_DK';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_ACCESSORIES_INWARD_REQUEST_DK = 'FETCH_SINGLE_ACCESSORIES_INWARD_REQUEST_DK';
export const FETCH_SINGLE_ACCESSORIES_INWARD_SUCCESS_DK = 'FETCH_SINGLE_ACCESSORIES_INWARD_SUCCESS_DK';
export const FETCH_SINGLE_ACCESSORIES_INWARD_FAILURE_DK = 'FETCH_SINGLE_ACCESSORIES_INWARD_FAILURE_DK';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_ACCESSORIES_INWARD_REQUEST_DK = 'DELETE_ACCESSORIES_INWARD_REQUEST_DK';
export const DELETE_ACCESSORIES_INWARD_SUCCESS_DK = 'DELETE_ACCESSORIES_INWARD_SUCCESS_DK';
export const DELETE_ACCESSORIES_INWARD_FAILURE_DK = 'DELETE_ACCESSORIES_INWARD_FAILURE_DK';

// USERFORM RESET

export const ACCESSORIES_INWARD_USERFORM_RESET_DK = 'ACCESSORIES_INWARD_USERFORM_RESET_DK';

// navigate to unit component
export const NAVIGATE_ACCESSORIES_INWARD_DETAILS_DK = 'NAVIGATE_ACCESSORIES_INWARD_DETAILS_DK';
// navigate to company component
export const NAVIGATE_ACCESSORIES_INWARD_DK = 'NAVIGATE_ACCESSORIES_INWARD_DK';

export const RESET_FORM_DATA_WITHOUT_ACCESSORIES_INWARD_ID_DK = 'RESET_FORM_DATA_WITHOUT_ACCESSORIES_INWARD_ID_DK';
export const SET_ACTIVE_KEY_ACCESSORIES_INWARD_DK = 'SET_ACTIVE_KEY_ACCESSORIES_INWARD_DK';
